import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import Head from '../components/head'
import aboutStyles from './about.module.scss'

const AboutPage = () => {
    return(
        <Layout>
        <Head title="About" />
        <p>nothing</p>
        </Layout>
    )
}

export default AboutPage
